"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _typography = _interopRequireDefault(require("../typography"));

var _constants = require("./constants");

var _chevronUp = _interopRequireDefault(require("../../assets/icons/chevron-up.svg"));

var _chevronDown = _interopRequireDefault(require("../../assets/icons/chevron-down.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.accordion-container .header-with-underline {\n  padding-bottom: 0.5rem;\n  cursor: pointer;\n  display: flex;\n  user-select: none;\n  border-bottom: 1px solid #a8a8a8; }\n\n.accordion-container .header-without-underline {\n  padding-bottom: 0.5rem;\n  cursor: pointer;\n  display: flex;\n  user-select: none; }\n\n.accordion-container .header img {\n  display: inline;\n  margin-right: 0.3125rem; }\n\n.accordion-container .header .margin-top-32 {\n  margin-top: 2rem; }\n\n.accordion-container .header .margin-top-8 {\n  margin-top: 0.5rem; }\n\n.accordion-container .content {\n  overflow: hidden; }\n  .accordion-container .content-expanded {\n    transition: 0.2s ease-out; }\n    .accordion-container .content-expanded-with-padding {\n      padding-top: 1.5rem;\n      padding-bottom: 1.5rem; }\n  .accordion-container .content-closed {\n    padding: 0;\n    visibility: hidden;\n    transition: 0.2s ease-in;\n    height: 0; }\n";
  var fileName = "compone_accordion";
  var element = document.querySelector("style[data-sass-component='compone_accordion']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Accordion = function Accordion(_ref) {
  var _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      title = _ref.title,
      _ref$hideUnderline = _ref.hideUnderline,
      hideUnderline = _ref$hideUnderline === void 0 ? false : _ref$hideUnderline,
      _ref$removeChildrenPa = _ref.removeChildrenPadding,
      removeChildrenPadding = _ref$removeChildrenPa === void 0 ? false : _ref$removeChildrenPa,
      children = _ref.children;

  var _useState = (0, _react.useState)(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "accordion-header",
    className: hideUnderline ? _constants.classes.headerWithoutUnderline : _constants.classes.headerWithUnderline,
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isExpanded ? _chevronUp.default : _chevronDown.default
  }), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, title)), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "accordion-content",
    className: "".concat(_constants.classes.content, " ").concat(isExpanded ? removeChildrenPadding ? _constants.classes.contentExpanded : _constants.classes.contentExpandedWithPadding : _constants.classes.contentClosed)
  }, children));
};

var _default = Accordion;
exports.default = _default;